import { useRef, useState } from 'react';

import { useAddressSavings } from '~src/hooks/graphql/useAddressSavings';
import { useOverrideAddressByID } from '~src/hooks/useDAWA/useOverrideAddressByID';
import { useNavigateToAdvisorBooking } from '~src/hooks/useNavigateToAdvisorBooking';
import { useCalculatorNavigation } from '~src/hooks/useNavigation';
import { ProductTypes } from '~src/model';
import { useAnalytics } from '~src/tracking/ga';

import { useDisabledTabsAndProductTypes } from './useDisabledTabsAndProductTypes';
import { useEstimatePageFinancing } from './useEstimatePageFinancing';
import { useEstimatePageResidenceAndProducts } from './useEstimatePageResidenceAndProducts';

export const useEstimatePage = (allowedProductTypes?: ProductTypes) => {
  const { trackEvent } = useAnalytics();

  const { addressID, address: addressInState } = useOverrideAddressByID();

  const scrollReference = useRef<HTMLDivElement>(null);

  const { data: savingsData } = useAddressSavings(addressID?.toString() ?? addressInState?.id?.toString());

  const { selectedProductTypes, setSelectedProductTypes, disabledProducts, takeover } =
    useDisabledTabsAndProductTypes(savingsData);

  const entry = savingsData?.results.find(({ types }) => selectedProductTypes.every(type => types.includes(type)));

  const { products, savings } = entry ?? {};

  const { residence, address, hasBbrData } = useEstimatePageResidenceAndProducts(allowedProductTypes);

  const { financing, financingProvider } = useEstimatePageFinancing(selectedProductTypes, products, residence);

  const navigate = useCalculatorNavigation('estimate');

  const navigateToBooking = useNavigateToAdvisorBooking();

  const [showLoan, setShowLoan] = useState(false);

  return {
    residence,
    scrollReference,
    address,
    navigate,
    trackEvent,
    navigateToBooking,
    products,
    financingProvider,
    financing,
    savings,
    showLoan,
    setShowLoan,
    fuelType: residence?.primaryHeating?.fuelType,
    hasBbrData,
    selectedProductTypes,
    setSelectedProductTypes,
    disabledProducts,
    takeover,
  };
};
